import { goBackendApi } from 'hooks/api/httpApi';

export const ACTIVATE_MARKET_DRIVEN_SHIPPING_PATH = '/api/v1/ecom/activate-market-driven';

/**
 * Switches the ecom to market-driven shipping. A LEGACY ecom is rejected with 400 — it has to be
 * migrated first.
 */
export const activateMarketDrivenShipping = () => goBackendApi().patch(ACTIVATE_MARKET_DRIVEN_SHIPPING_PATH);
